Pixlee.module("WidgetsApp.Photowall", function(Photowall, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    Photowall.PhotoView = App.Views.ItemView.extend({
        template: require('../common/templates/_photos_item_v2.jst.ejs'),
        className: 'photo-item-container',
        ui: {
            layer_share: ".layer_share",
            vote_container: ".vote_container",
            vote_text: ".vote_text",
            vote_counter: ".vote_counter"
        },
        events: {
            "click .share_panel_button_w_vote": 'showSocial',
            "click .close_share_button": 'hideSocial',
            "click .vote_button": 'voteShareClicked',
            "click .pixlee_pinit": 'sharePinterest',
            "click .pixlee_tweet": 'shareTwitter',
            "click .pixlee_tumblr": 'shareTumblr',
            "click .pixlee_fshare": 'shareFacebook',
            "mouseenter .photo_block": 'showCaption',
            "mouseleave .photo_block": 'hideCaption'
        },
        showCaption: function() {
            if (gon.v2 && !gon.packery) {
                var imgHeight = $(this.el).find('.img_holder').height();
                var caption = $(this.el).find('.image_info').height();
                $(this.el).find('.img_holder').height(imgHeight - caption);
                $(this.el).find('svg').css('bottom', (caption - 1) + 'px');
                $(this.el).find('.social_holder').css('bottom', (caption + 7) + 'px');
            }
        },
        hideCaption: function() {
            if (gon.v2 && !gon.packery) {
                $(this.el).find('.img_holder').height(this.getHeight());
                $(this.el).find('svg').css('bottom', '0px');
                $(this.el).find('.social_holder').css('bottom', '0px');
            }
        },
        getHeight: function() {
            if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                return '150px';
            } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                return '200px';
            } else if (gon.display_options) {
                return '260px';
            }
        },
        changeImage: function() {
            var _this = this;
            var model = gon.fresh_images[0];
            if (!model) return false;
            gon.fresh_images.shift();
            var Active = this.$el.find('.img_holder').not('.inactivated');
            var inActive = this.$el.find('.img_holder.inactivated');
            _this.model.collection.get(_this.model.id).attributes = model.attributes;
            _this.model.attributes = model.attributes;
            var helpers = _this.templateHelpers();
            for (i in model.attributes) {
                helpers[i] = model.attributes[i];
            }
            var url = helpers.photoURL.call(helpers, 'xl');
            inActive.find('img').attr('src', url);

            imagesLoaded(inActive[0], function() {

                inActive.css('background-image', 'url(' + url + ')').removeClass('inactivated').css('z-index', '2');
                Active.css('background-image', 'url(' + url + ')').css('z-index', '0');
                Active.addClass('inactivated');
                inActive.attr('id', model.attributes.album_photo_id).attr('href', url);
                Active.attr('id', model.attributes.album_photo_id).attr('href', url);
                setTimeout(function() {
                    App.commands.execute('lightbox:init', _this.model.collection);
                    _this.$el.cycle('next');
                }, 50);
            });
        },
        sharePinterest: function() {
            this.trigger('share:pinterest', this.model);
            return false;
        },
        shareTwitter: function() {
            this.trigger('share:twitter', this.model);
            return false;
        },
        shareTumblr: function() {
            this.trigger('share:tumblr', this.model);
            return false;
        },
        shareFacebook: function() {
            this.trigger('share:facebook', this.model);
            return false;
        },
        triggers: {
            'click .lightboxed': 'show:lighbox'
        },
        initialize: function() {
            this.album = App.request("get:current:album").toJSON();
            this.model.on('voted', this.toggleVote, this);
        },
        showSocial: function() {
            this.ui.layer_share.show();
        },
        hideSocial: function() {
            this.ui.layer_share.hide();
        },
        templateHelpers: function() {
            var _this = this;
            return _.extend({
                displayOptions: App.reqres.request("get:display:options").toJSON(),
                currentAlbum: App.reqres.request("get:current:album").toJSON(),
                recipe: App.reqres.request("get:recipe").toJSON(),
                getVoteShareText: function() {
                    if (gon.display_options.customVoteText) {
                        return gon.display_options.customVoteText;
                    }
                    if (this.currentAlbum.campaign) {
                        return "Vote";
                    }
                    return "Share";
                },
                voted: function() {
                    var preVoted = false;
                    var _this = this;
                    if ($.cookie('pixlee_likes')) {
                        var cookies = JSON.parse($.cookie('pixlee_likes'));
                        _.each(cookies, function(cookie) {
                            if (cookie == _this.album_id + '_' + _this.album_photo_id) {
                                preVoted = true;
                            }
                        });
                    } else if ($.cookie('pixlee_likes_legacy')) {
                        var cookies = JSON.parse($.cookie('pixlee_likes_legacy'));
                        _.each(cookies, function(cookie) {
                            if (cookie == _this.album_id + '_' + _this.album_photo_id) {
                                preVoted = true;
                            }
                        });
                    }
                    return (this.userVoted || preVoted);
                },
                widget: function() {
                    return gon.widget;
                }
            }, App.request("concern", "PhotoHelpers"));
        },
        getActionLink: function() {
            if (!_.isFalsy(this.model.get('action_link'))) {
                return this.model.get('action_link');
            }
            if (!_.isFalsy(gon.display_options.customCallToActionLink)) {
                return gon.display_options.customCallToActionLink;
            }
            return "";
        },
        voteShareClicked: function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            if (!gon.current_album.campaign) {
                this.showSocial();
            } else {
                if (!this.ui.vote_container.hasClass('voted')) {
                    this.trigger("vote:clicked", this.model);
                }
            }
        },
        toggleVote: function(e) {
            this.ui.vote_container.addClass("voted");
            this.ui.vote_text.text(!_.isFalsy(gon.display_options.customVotedText) ? App.request("decode:utf8", gon.display_options.customVotedText) : "voted");
            if (this.ui.vote_counter.length) {
                if (this.model.get("like_count")) {
                    this.ui.vote_counter.text(": " + this.model.get("like_count"));
                }
            }
        }
    });

    Photowall.MobilePhotoView = Photowall.PhotoView.extend({
        template: require('../common/templates/_mobile_photos_item.jst.ejs')
    });

    Photowall.PhotoWallCollectionView = App.Views.CollectionView.extend({
        childView: Photowall.PhotoView,
        className: "transitions-enabled infinite-scroll clearfix",
        id: "container",
        onAddChild: function(child) {
            var view = child;
            // if (view.model.get('source') === 'vine' || view.model.get('source') === 'instagram_video') {
            // 	$(view.el).find('.layer_video').attr('href' , view.model.get('thumbnail_url')).attr('rel', 'album');
            // } else {
            // 	$(view.el).find('.img_holder').attr('href' , view.model.get('source_url')).attr('rel', 'album');
            // }
            // App.Views.MasonryCollectionView.prototype.onAddChild.call(this, view);
        },
        onRender: function(argument) {

        }
    });
    Photowall.PhotoWallCollectionView.include(["MasonryCollectionView"]);



    Photowall.PhotoWallMobileCollectionView = App.Views.CollectionView.extend({
        childView: Photowall.MobilePhotoView,
        className: "infinite-scroll clearfix",
        id: "container"
    });
    Photowall.PhotoWallMobileCollectionView.include(["MasonryCollectionView"]);

    Photowall.HorizontalMobileCollectionView = App.Views.CollectionView.extend({
        childView: Photowall.MobilePhotoView,
        className: "infinite-scroll clearfix",
        id: "container",
        onRender: function() {
            var _this = this;
            var t;
            if (!this.scrollInitialized) {
                $('#photos_region').on('scroll', function() {
                    clearTimeout(t);
                    t = setTimeout(function() {
                        var width = $('#photos_region')[0].scrollWidth - $('#photos_region')[0].clientWidth;
                        var scrollLeft = $('#photos_region').scrollLeft();
                        if ((scrollLeft / width) > 0.7) {
                            _this.trigger("load:more:horizontal");
                        }
                    }, 500);
                });
                this.scrollInitialized = true;
            }

        }
    });
    Photowall.HorizontalMobileCollectionView.include(["HorizontalCollectionView"]);



    Photowall.HorizontalCollectionView = App.Views.CollectionView.extend({
        childView: Photowall.PhotoView,
        className: "transitions-enabled infinite-scroll clearfix",
        id: "container",
        initialize: function() {
            this.current = 0;
        },
        navLeft: function() {
            if (this.current > 0) {
                this.sly.prevPage();
                this.current--;
                var photos = this.getCurrentItemIds();
                this.showOrHideArrows();
                if (photos.length > 0) App.commands.execute('nav:left', photos);
            }

        },
        navRight: function() {
            if (this.current < (this.sly.pages.length)) {
                this.sly.nextPage();
                this.current++;
                var photos = this.getCurrentItemIds();
                this.showOrHideArrows();
                if (photos.length > 0) App.commands.execute('nav:right', photos);
            }
        },
        getCurrentItemIds: function() {
            var photos = [];
            var rel = this.sly.rel;
            var first = rel.firstItem;
            var second = rel.lastItem;
            this.collection.each(function(model) {
                if (model.get('album_photo_id')) {
                    photos.push(model.get('album_photo_id'));
                }
            });
            photos = photos.slice(rel.firstItem, rel.lastItem + 1);
            return photos;
        },
        onRender: function() {
            $('#left-nav-arrow').addClass('inactive-arrow');
        },
        showOrHideArrows: function() {
            if (this.current > (this.sly.pages.length - this.current)) {
                if (this.collection.next) {
                    this.initLoader = false;
                    this.showLoader();
                    this.loaded = false;
                    this.trigger("load:more:horizontal");
                }
            }
            if (this.current === 0) {
                $('#left-nav-arrow').addClass('inactive-arrow').removeClass('active-arrow');
                $('#right-nav-arrow').addClass('active-arrow');
            } else if (this.current === (this.sly.pages.length - 1)) {
                $('#left-nav-arrow').addClass('active-arrow');
                $('#right-nav-arrow').addClass('inactive-arrow').removeClass('active-arrow');

            } else if (this.current < (this.sly.pages.length) && this.current > 0) {
                $('#left-nav-arrow').removeClass('inactive-arrow').addClass('active-arrow');
                $('#right-nav-arrow').removeClass('inactive-arrow').addClass('active-arrow');
            }
        }
    });
    Photowall.HorizontalCollectionView.include(["HorizontalCollectionView"]);

});
